import { ActionButton as FabricActionButton } from '@fluentui/react/lib/Button';
import { withButtonClickLogging } from './withButtonClickLogging';
export const ActionButton = withButtonClickLogging(FabricActionButton);
//# sourceMappingURL=ActionButton.js.map